import React, { useEffect, useState } from "react"
import logo from "../../images/logo/foxconnLogo.png"
import "./Header.scss"

const Header = () => {
  const [navbarOpened, setNavBarOpened] = useState(false);
  const [dropDownOpened, setDropDownOpened] = useState(false);

  const toggleNav = () => {
    setNavBarOpened(!navbarOpened);
  };

  const toggleDropDown = () => {
    setDropDownOpened(!dropDownOpened);
  };
  return (
    <header>
      <nav className="navbar navbar-expand-lg" id="mainNav">
        <div className="container">
          <a className="navbar-brand" href="https://prace.foxconn.cz/">
              <img src={logo} alt="" />
          </a>
          <button className="navbar-toggler" onClick={toggleNav} type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="fa fa-bars"></span>
          </button>
          <div className={`${navbarOpened ? "" : "collapse "}navbar-collapse collapseMenu`} id="navbarNav">
            <ul className="navbar-nav ml-auto order-0">
              <li className="nav-item">
                <a className="nav-link" aria-current="page" href="https://prace.foxconn.cz/search">VOLNÁ MÍSTA</a>
              </li>
              <li className="nav-item dropdown" onClick={toggleDropDown}>
                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  Poznejte nás
                </a>
                <ul className={`${dropDownOpened ? "show" : ""} dropdown-menu`} aria-labelledby="navbarDropdownMenuLink">
                  <li><a className="dropdown-item" href="https://prace.foxconn.cz/content/O-Foxconnu/?locale=cs_CZ">O Foxconnu</a></li>
                  <li><a className="dropdown-item" href="https://prace.foxconn.cz/content/Nasi-lide/?locale=cs_CZ">Naši lidé a jejich příběhy</a></li>
                  <li><a className="dropdown-item" href="https://prace.foxconn.cz/content/Nase-oddeleni/?locale=cs_CZ">Naše oddělení</a></li>
                  <li><a className="dropdown-item" href="https://prace.foxconn.cz/content/Proces-naboru/?locale=cs_CZ">Jak probíhá nábor</a></li>
                </ul>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://prace.foxconn.cz/content/Blog/?locale=cs_CZ">Blog</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://prace.foxconn.cz/content/Benefity/?locale=cs_CZ">Benefity</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://prace.foxconn.cz/content/Kontakty/?locale=cs_CZ">Kontakty</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://career2.successfactors.eu/careers?site=&company=foxconnczs&clientId=jobs2web&lang=cs_CZ&navBarLevel=MY_PROFILE">Přihlášení</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  )
}

export default Header
